import { createContext, ReactNode, useState, useContext, useEffect, useCallback } from "react";
import {
  checkHasAuthToken,
  setAuthToken,
  removeAuthToken,
} from "../../client/token-utils";
import { unauthorizedEvent } from "../../client/http-client";

export interface LoginResponse {
  status: boolean;
  message: string;
  data: Data;
}

export interface Data {
  token: string;
}


interface userDataType {
  token: string
  name: {
    value: string
    text: any
  }
  bde: {
    value: string
    text: string
  }
  bdeEmail: {
    value: string
    text: any
  }
  salesRep: {
    value: string
    text: string
  }
  SalesRepEmail: {
    value: string
    text: any
  }
  branch:{
    value: string
    text: any
  }
}


interface AuthContextProps {
  isAuthorized: boolean;
  authorize: (data: LoginResponse,userData: userDataType) => void;
  unauthorize: () => void;
  branch: string;
  setBranch: (branch: string) => void;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

interface UserContextProviderProps {
  children: ReactNode;
}

export const UserContextProvider: React.FC<UserContextProviderProps> = ({
  children,
}) => {
  const [isAuthorized, setIsAuthorized] = useState(checkHasAuthToken());
  const [branch, setBranch] = useState('');

  const unauthorize = useCallback(() => {
    setIsAuthorized(false);
    removeAuthToken();

    window.location.href = "/login";
  }, []);

  const contextValue: AuthContextProps = {
    isAuthorized,
    authorize(data, userData) {
      setIsAuthorized(true);
      setAuthToken(data.data.token);
    },
    branch,
    setBranch,
    unauthorize,
  };

  useEffect(() => {
    const handleUnauthorized = () => {
      unauthorize();
    };

    window.addEventListener(unauthorizedEvent.type, handleUnauthorized);

    return () => {
      window.removeEventListener(unauthorizedEvent.type, handleUnauthorized);
    };
  }, [unauthorize]);

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserContextProvider");
  }
  return context;
};
